module.exports = __webpack_public_path__ + "static/media/More.80ab70f7.svg";